import { Link as RouterLink } from 'react-router-dom'
import { trackCTAClick } from '../services/analytics'
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Button,
  Icon,
} from '@chakra-ui/react'
import { FaFilePdf, FaVideo } from 'react-icons/fa'

const ResourceCard = ({ icon, title, description, children, bg }) => (
  <VStack
    align="stretch"
    gap={5}
    p={{ base: 6, md: 8 }}
    bg={bg}
    rounded="3xl"
    h="full"
  >
    <Box
      w={14}
      h={14}
      rounded="2xl"
      bg="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
      boxShadow="sm"
    >
      <Icon as={icon} boxSize={6} color="purple.600" />
    </Box>
    <Heading size="md" color="gray.800">
      {title}
    </Heading>
    <Text color="gray.600" lineHeight="tall" flex="1">
      {description}
    </Text>
    {children}
  </VStack>
)

const LandingRecursos = () => (
  <Box id="recursos" bg="white" py={{ base: 16, md: 24 }} data-landing="recursos">
    <Container maxW="7xl">
      <VStack gap={{ base: 10, md: 14 }}>
        <VStack gap={4} textAlign="center">
          <Heading
            as="h2"
            fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
            fontWeight="800"
            color="gray.800"
          >
            Aprende a usar Cadencya
          </Heading>
          <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" maxW="2xl">
            Webinarios en directo y un manual para consultar cuando quieras.
          </Text>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 2 }} gap={{ base: 6, md: 8 }} w="full">
          <ResourceCard
            icon={FaVideo}
            bg="purple.50"
            title="Webinarios online"
            description="Sesiones en directo para explicar cómo funciona la plataforma y resolver dudas. Cuando haya una fecha concreta, la publicaremos aquí. Si quieres que te avisemos, escríbenos."
          >
            <Button
              colorPalette="purple"
              rounded="full"
              alignSelf="flex-start"
              asChild
            >
              <RouterLink
                to="/contacto?asunto=Avisadme%20del%20pr%C3%B3ximo%20webinario"
                onClick={() => trackCTAClick('webinario', 'landing_recursos')}
              >
                Avísame del próximo
              </RouterLink>
            </Button>
          </ResourceCard>

          <ResourceCard
            icon={FaFilePdf}
            bg="gold.50"
            title="Manual de usuario"
            description="Guía de inicio: registro, validación, plantilla, archivo, ensayos, permisos y tu web. Descárgala o consúltala en el navegador."
          >
            <Button
              colorPalette="purple"
              variant="outline"
              rounded="full"
              alignSelf="flex-start"
              asChild
            >
              <a
                href="/manual-usuario-cadencya.pdf?v=20260927"
                download
                onClick={() => trackCTAClick('manual_pdf', 'landing_recursos')}
              >
                Descargar el manual
              </a>
            </Button>
            <Button variant="plain" color="purple.700" fontWeight="700" alignSelf="flex-start" asChild>
              <RouterLink to="/manual" onClick={() => trackCTAClick('manual', 'landing_recursos')}>
                Leer en el navegador
              </RouterLink>
            </Button>
          </ResourceCard>
        </SimpleGrid>
      </VStack>
    </Container>
  </Box>
)

export default LandingRecursos
